import ProgramForm from '@apps/crm/admin/components/programform'
import Edit from '@apps/team/admin/views/senders/edit'
import New from '@apps/team/admin/views/senders/new'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Senders)',
  access: { rights: { $oneOf: ['team:view_senders','team:manage_senders'] } },
  collection: {
    endpoint: '/api/admin/team/senders',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Sender)', key: 'rfc822', sort: 'name', primary: true },
      ...context.admin.team.has_programs ? [
        { label: 't(Program)', key: 'program.title', sort: 'program', collapsing: true }
      ] : [],
      { label: 't(Verification)', key: 'email_status', primary: true, collapsing: true, format: StatusToken }
    ],
    empty: {
      title: 't(No Senders)',
      text: 't(You have not yet created any senders)',
      icon: 'paper-plane-o',
      buttons: [
        { 
          label: 't(Create Senders)',
          access: { rights: { $oneOf: ['team:manage_senders'] } },
          modal: <ProgramForm form={ New } />
        }
      ]
    },
    export: [
      { label: 't(ID)', key: 'id' },
      { label: 't(Name)', key: 'name' },
      { label: 't(Email)', key: 'email' }
    ],
    recordTasks: (record) => [
      { 
        label: 't(Edit Sender)', 
        svg: 'square_pen',
        access: { rights: { $oneOf: ['team:manage_senders'] } },
        modal: <Edit sender={ record } /> 
      },
      {
        label: 't(Make Default)',
        svg: 'star', 
        access: { rights: { $oneOf: ['team:manage_senders'] } },
        show: !record.is_default && record.status === 'verified',
        request: {
          endpoint: `/api/admin/team/senders/${record.id}/activate`,
          method: 'PATCH',
          onFailure: () => context.flash.set('error', 't(Unable to make sender default)'),
          onSuccess: () => context.flash.set('success', 't(Successfully to made sender default)')
        }
      },
      {
        label: 't(Delete Sender)',
        svg: 'trash',
        access: { rights: { $oneOf: ['team:manage_senders'] } },
        confirm: 't(Are you sure you want to delete this sender?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/team/senders/${record.id}`,
          method: 'DELETE',
          onFailure: () => context.flash.set('error', 't(Unable to delete sender)'),
          onSuccess: () => context.flash.set('success', 't(Successfully deleted sender)')
        }
      }
    ],
    entity: 'sender',
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/admin/team/senders/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Create Senders)',
    access: { rights: { $oneOf: ['team:manage_senders'] } },
    modal: <ProgramForm form={ New } />
  }
})

export default Panel(null, mapPropsToPanel)
